import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SkierResortViewReport from '../components/SkierResortViewReport';
import GogglesCrashesReport from '../components/GogglesCrashesReport';
import GogglesSWAdoptionReport from '../components/GogglesSWAdoptionReport';
import GogglesConnectivityReport from '../components/GogglesConnectivityReport';
import GogglesUsageReport from '../components/GogglesUsageReport';
import WaypointsUsageReport from '../components/WaypointsUsageReport';
import OtaAttemptsReport from '../components/OtaAttemptsReport';
import FirebaseErrorReport from '../components/FirebaseErrorReport';
import AuthIssuesReport from '../components/AuthIssuesReport';
import MiniMapReport from '../components/MiniMapReport';
import BleSerialLogUploadsReport from '../components/BleSerialLogUploadsReport';
import './AnalyticsPage.css';

const VALID_REPORTS = ['skier-resort-view', 'goggles-crashes', 'goggles-sw-adoption', 'goggles-connectivity', 'goggles-usage', 'waypoints-usage', 'ota-attempts', 'firebase-error', 'auth-issues', 'mini-map', 'ble-serial-log-uploads'];

const AnalyticsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const reportParam = searchParams.get('report');
  const activeReport = VALID_REPORTS.includes(reportParam) ? reportParam : 'skier-resort-view';

  const handleTabChange = (report) => {
    setSearchParams(report === 'skier-resort-view' ? {} : { report });
  };

  return (
    <div className="analytics-page">
      <div className="analytics-page-header">
        <h1 className="analytics-page-title">Analytics</h1>
        <div className="analytics-page-tabs">
          <button
            className={`analytics-page-tab ${activeReport === 'skier-resort-view' ? 'active' : ''}`}
            onClick={() => handleTabChange('skier-resort-view')}
          >
            Skier Resort View
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'goggles-crashes' ? 'active' : ''}`}
            onClick={() => handleTabChange('goggles-crashes')}
          >
            Goggles Crashes
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'goggles-sw-adoption' ? 'active' : ''}`}
            onClick={() => handleTabChange('goggles-sw-adoption')}
          >
            Goggles SW Adoption
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'goggles-connectivity' ? 'active' : ''}`}
            onClick={() => handleTabChange('goggles-connectivity')}
          >
            Goggles Connectivity
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'goggles-usage' ? 'active' : ''}`}
            onClick={() => handleTabChange('goggles-usage')}
          >
            Goggles Usage
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'waypoints-usage' ? 'active' : ''}`}
            onClick={() => handleTabChange('waypoints-usage')}
          >
            Waypoints Usage
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'ota-attempts' ? 'active' : ''}`}
            onClick={() => handleTabChange('ota-attempts')}
          >
            OTA Attempts
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'firebase-error' ? 'active' : ''}`}
            onClick={() => handleTabChange('firebase-error')}
          >
            Firebase Errors
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'auth-issues' ? 'active' : ''}`}
            onClick={() => handleTabChange('auth-issues')}
          >
            Auth Issues
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'mini-map' ? 'active' : ''}`}
            onClick={() => handleTabChange('mini-map')}
          >
            Mini Map
          </button>
          <button
            className={`analytics-page-tab ${activeReport === 'ble-serial-log-uploads' ? 'active' : ''}`}
            onClick={() => handleTabChange('ble-serial-log-uploads')}
          >
            BLE Serial Log Uploads
          </button>
        </div>
      </div>

      <div className="analytics-page-content">
        {activeReport === 'skier-resort-view' && <SkierResortViewReport />}
        {activeReport === 'goggles-crashes' && <GogglesCrashesReport />}
        {activeReport === 'goggles-sw-adoption' && <GogglesSWAdoptionReport />}
        {activeReport === 'goggles-connectivity' && <GogglesConnectivityReport />}
        {activeReport === 'goggles-usage' && <GogglesUsageReport />}
        {activeReport === 'waypoints-usage' && <WaypointsUsageReport />}
        {activeReport === 'ota-attempts' && <OtaAttemptsReport />}
        {activeReport === 'firebase-error' && <FirebaseErrorReport />}
        {activeReport === 'auth-issues' && <AuthIssuesReport />}
        {activeReport === 'mini-map' && <MiniMapReport />}
        {activeReport === 'ble-serial-log-uploads' && <BleSerialLogUploadsReport />}
      </div>
    </div>
  );
};

export default AnalyticsPage;
